import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=2c0935dc&scoped=true&"
import script from "./Footer.vue?vue&type=script&lang=js&"
export * from "./Footer.vue?vue&type=script&lang=js&"
import style0 from "../../assets/js/common/footer.css?vue&type=style&index=0&id=2c0935dc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0935dc",
  null
  
)

export default component.exports